<template>
	<div class="login">
		<vue-particles v-if="show" color="#dedede" :particleOpacity="0.7" :particlesNumber="80" shapeType="circle"
		 :particleSize="4" linesColor="#dedede" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150"
		 :moveSpeed="4" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
		</vue-particles>
		<div class="login-contain">
			<div class="login-wrapper animated zoomIn">
				<div class="login-title">登录</div>
				<div class="login-input" :class="{'login-input-success': userOk, 'login-input-warn': userWarn}">
					<div class="icon-font" style="margin-right: 0.63vw">&#xe6f4;</div>
					<input placeholder="请输入用户名" name="user" type="text" v-model="user" @keyup.enter.native="handleLogin" />
					<transition name="slide-fade">
						<div class="icon-font enter-ok" v-if="userOk">&#xe67f;</div>
					</transition>
				</div>
				<div class="login-input" :class="{'login-input-success': passwordOk, 'login-input-warn': passwordWarn}">
					<div class="icon-font" style="margin-right: 0.63vw">&#xe63d;</div>
					<input placeholder="请输入密码" name="password" v-model="password" :type="type" @keyup.enter.native="handleLogin" />
					<div class="icon-font invisible" v-if="!visible" @click="hidePassword">&#xebcd;</div>
					<div class="icon-font visible" v-if="visible" @click="showPassword">&#xebcc;</div>
					<transition name="slide-fade">
						<div class="icon-font enter-ok" v-if="passwordOk">&#xe67f;</div>
					</transition>
				</div>
				<div class="login-button" :class="{'login-button-active': userOk && passwordOk}" @click="handleLogin">登录</div>
			</div>
			<div class="obscuration" v-if="loading"></div>
			<div class="loading-data" v-if="loading">
				<i class="el-icon-loading"></i>
				<div>登录中···</div>
			</div>
		</div>
	</div>
</template>

<script>
	import localforage from 'localforage'
	import {
		login,
		loginUid
	} from '../../api/login'
	export default {
		name: 'Login',
		data() {
			return {
				show: false,
				loading: false,
				user: '',
				password: '',
				type: 'password',
				checked: false,
				userOk: false,
				userWarn: false,
				passwordWarn: false,
				passwordOk: false,
				visible: false,
				canLogin: true,
				// uid请求数据
				iv_user: '',
				iv_server_name: ''
			}
		},
		created() {
			this.getUid()
			let _this = this
			localforage.getItem('userInfo').then(res => {
				if (res) {
					_this.user = res.user
					_this.password = res.password
					_this.checked = res.checked
				}
			})
			document.onkeydown = function(e) {
				let key = e.keyCode
				if (key === 13) {
					_this.handleLogin()
				}
			}
			setTimeout(function() {
				_this.show = true
			}, 500)
		},
		watch: {
			user: function() {
				this.userOk = this.user && this.user.length > 0
				this.userWarn = this.user && this.user.length <= 0
			},
			password: function() {
				this.passwordOk = this.password && this.password.length > 0
				this.passwordWarn = this.password && this.password.length <= 0
			}
		},
		methods: {
			getUid: function() {
				let _this = this
				let uid = window.location.href
				uid = uid.split('#')[0].split('/')
				uid = uid[uid.length - 1]
				let body = {
					UID: uid
				}
				loginUid(body).then(res => {
					console.log(res)
					localforage.setItem('user_Info', res.data)
					_this.loading = false
					if (res.code === 200) {
						_this.$message({
							message: '登录成功！',
							type: 'success',
							center: 'true',
							duration: '1000',
							customClass: 'login-message'
						})
					} else {
						_this.$message({
							message: res.message,
							type: 'success',
							center: 'true',
							duration: '3000',
							customClass: 'login-message'
						})
					}
					_this.$router.push({
						path: '/oneMenu',
						query: {
							code: res.code
						}
					})
					_this.canLogin = true
				}).catch(err => {
					console.log(err)
					_this.loading = false
					_this.canLogin = true
				})
			},
			hidePassword: function() {
				this.visible = true
				this.type = 'text'
			},
			showPassword: function() {
				this.visible = false
				this.type = 'password'
			},
			handleLogin: function() {
				let _this = this
				let data
				if (_this.checked) {
					data = {
						user: _this.user,
						password: _this.password,
						checked: true
					}
				} else {
					data = {
						user: '',
						password: '',
						checked: false
					}
				}
				localforage.setItem('userInfo', data).then(function() {
					if (_this.passwordOk && _this.userOk) {
						_this.loading = true
						let body = {
							account: _this.user,
							password: _this.password
						}
						_this.canLogin = false
						login(body).then(res => {
							console.log(res)
							console.log('1111111')
							localforage.setItem('user_Info', res.data)
							_this.loading = false
							if (res.code === 200) {
								_this.$message({
									message: '登录成功！',
									type: 'success',
									center: 'true',
									duration: '1000',
									customClass: 'login-message'
								})
							} else {
								_this.$message({
									message: res.message,
									type: 'success',
									center: 'true',
									duration: '3000',
									customClass: 'login-message'
								})
							}
							_this.$router.push({
								path: '/oneMenu',
								query: {
									code: res.code
								}
							})
							_this.canLogin = true
						}).catch(err => {
							console.log(err)
							_this.loading = false
							_this.canLogin = true
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.login {
		width: 100vw;
		height: 100vh;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		background-image: url("../../assets/sky.jpg");
		background-size: cover;
	}

	.login-wrapper {
		padding: 1.5vw 2vw;
		background-color: #ffffff;
		border-radius: 0.5vw;
		width: 20vw;
		box-shadow: 0 0 2vw #999;
	}

	.login-title {
		text-align: center;
		color: #00b7ee;
		font-size: 1.5vw;
	}

	.login-input {
		margin-top: 1.5vw;
		width: 100%;
		border-radius: 0.3vw;
		border: solid 0.05vw #c0c4cc;
		padding: 0.63vw;
		position: relative;
		color: #c0c4cc;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		transition: all .3s ease;
	}

	.login-input-success {
		border: solid 0.05vw #00b7ee;
	}

	.login-input-warn {
		border: solid 0.05vw #f56c6c;
	}

	.login-button {
		background-color: #00b7ee;
		width: 100%;
		padding: 0.63vw;
		text-align: center;
		margin-top: 1.5vw;
		color: #ffffff;
		font-size: 0.83vw;
		border-radius: 0.5vw;
		opacity: 0.5;
	}

	.login-button-active {
		opacity: 1;
		cursor: pointer;
	}

	input {
		position: relative;
		z-index: 1;
		padding: 0;
		background-color: transparent;
		border: 0;
		outline: none;
		color: #2e2e2e;
		width: 100%;
		height: 100%;
		font-size: 0.83vw;
	}

	input::-webkit-input-placeholder,
	textarea::-webkit-input-placeholder {
		color: #c0c4cc !important;
		font-size: 0.83vw !important;
	}

	input:-moz-placeholder,
	textarea:-moz-placeholder {
		color: #c0c4cc !important;
		font-size: 0.83vw !important;
	}

	input::-moz-placeholder,
	textarea::-moz-placeholder {
		color: #c0c4cc !important;
		font-size: 0.83vw !important;
	}

	input:-ms-input-placeholder,
	textarea:-ms-input-placeholder {
		color: #c0c4cc !important;
		font-size: 0.83vw !important;
	}

	.login-check {
		width: 100%;
		margin-top: 1.25vw;
		display: flex;
		justify-content: flex-start;
	}

	.icon-font {
		margin-top: 0;
	}

	.invisible {
		cursor: pointer;
		font-size: 1vw;
		transition: all .3s ease;
	}

	.visible {
		color: #00b7ee;
		cursor: pointer;
		font-size: 1vw;
		transition: all .3s ease;
	}

	.enter-ok {
		color: #00b7ee;
		font-size: 0.8vw;
	}

	.obscuration {
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #000000;
		z-index: 9998;
		opacity: 0.3;
	}

	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all .3s ease;
	}

	.slide-fade-leave-active {
		transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}

	#particles-js {
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
	}
</style>



// WEBPACK FOOTER //
// src/page/login/loginGetUid.vue